"use strict";

module.exports = {
  strings: {
    timedOut: 'Upload stalled for %{seconds} seconds, aborting.'
  }
};